module.exports = __webpack_public_path__ + "img/rain.58bc0db8.jpg";